export const randomBool = (weight = 0.5): boolean => Math.random() <= weight
export const randomInt = (min, max): number =>
  Math.floor(Math.random() * (max - min + 1) + min)
